import React from 'react';
import { Helmet } from 'react-helmet-async';
import WebDev from '../components/WebDev';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Web Development', item: 'https://wayug.com/web-development' },
  ],
};

export default function WebDevPage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Website &amp; Web Application Development Company Delhi NCR | Wayug</title>
        <meta
          name="description"
          content="Custom website development and high-performance web applications in React, Next.js &amp; Node.js. Fast, secure, SEO-optimized web development in Delhi NCR."
        />
        <link rel="canonical" href="https://wayug.com/web-development" />
        <meta property="og:title" content="Website &amp; Web Application Development | Wayug Infotech" />
        <meta
          property="og:description"
          content="Custom web portals, SaaS platforms, and enterprise websites engineered for speed, security, and high conversion."
        />
        <meta property="og:url" content="https://wayug.com/web-development" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <WebDev />
    </div>
  );
}
